export function hero() {
    $(window).on("load", function () {
        $('.hero-section .i').on('click', function () {
            $(this).closest('.image').toggleClass('show-caption');
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/hero.js